import React from 'react';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import { Entry } from 'contentful';
import { Row } from '@sumup-oss/circuit-ui/legacy';

import Article from '../components/Article';

import SectionsList from 'components/SectionsList';
import MobileSectionsList from 'components/MobileSectionsList';
import {
  ContentfulArticle,
  SectionTree,
  SectionTypeTree,
  IDSEscalationOption,
  ContentfulCountry,
} from 'types/common';
import {
  PageNavigation,
  PageContent,
  PreviewEditButton,
} from 'components/styledComponents';
import { makeContentfulEntryUrl } from 'services/contentful';

type ArticlePageProps = {
  articleData: ContentfulArticle;
  articleId: string;
  chatAvailable: boolean;
  countriesData: Entry<ContentfulCountry>[];
  escalationOptions: IDSEscalationOption[];
  preview: boolean | null;
  sectionTypeTree: SectionTypeTree;
  sectionTree: SectionTree;
};

const Page: NextPage<ArticlePageProps> = ({
  articleData,
  chatAvailable,
  countriesData,
  escalationOptions,
  sectionTypeTree,
  preview,
  sectionTree,
}) => {
  const router = useRouter();
  if (router.isFallback) {
    // TODO add a loader
    return null;
  }

  return (
    <Row>
      <PageNavigation span="0" skip="0">
        <MobileSectionsList
          sectionTypeTree={sectionTypeTree}
          sectionTree={sectionTree}
        />
        <SectionsList
          sectionTypeTree={sectionTypeTree}
          sectionTree={sectionTree}
        />
      </PageNavigation>

      <PageContent span="0" skip="0">
        {preview && (
          <PreviewEditButton
            href={makeContentfulEntryUrl(articleData.sys.id)}
            target="blank"
          >
            Edit
          </PreviewEditButton>
        )}
        {articleData && (
          <Article
            articleData={articleData}
            countriesData={countriesData}
            chatAvailable={chatAvailable}
            escalationOptions={escalationOptions}
          />
        )}
      </PageContent>
    </Row>
  );
};

export default Page;
